module.exports = __webpack_public_path__ + "img/img-sarita-allen@2x.cf67be5f.png";